export const userProfileQueryKeys = {
    all: ['users', 'profile'] as const,
    byId: (userId: number | undefined) => [...userProfileQueryKeys.all, userId] as const,
}
